import { render, staticRenderFns } from "./change-claim-status.vue?vue&type=template&id=dd8e4b04&scoped=true&"
import script from "./change-claim-status.vue?vue&type=script&lang=js&"
export * from "./change-claim-status.vue?vue&type=script&lang=js&"
import style0 from "./change-claim-status.vue?vue&type=style&index=0&id=dd8e4b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8e4b04",
  null
  
)

export default component.exports